import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

const PLACEHOLDER =
  "data:image/svg+xml;charset=utf-8," +
  encodeURIComponent(
    "<svg xmlns='http://www.w3.org/2000/svg' width='400' height='400'><rect width='400' height='400' fill='#F4EFE6'/><text x='200' y='210' font-family='sans-serif' font-size='24' font-weight='bold' fill='#B8AE98' text-anchor='middle'>Nabor</text></svg>"
  );

export function imageUrl(src) {
  if (!src) return PLACEHOLDER;
  if (src.startsWith("http") || src.startsWith("data:")) return src;
  return `${BACKEND_URL}${src.startsWith("/") ? "" : "/"}${src}`;
}

export function money(n) {
  return "£" + Number(n || 0).toFixed(2);
}

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
